import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { RouterModule } from '@angular/router';

import { ButtonComponent } from '../../button';
import { IconComponent } from '../../icon';
import { ChecklistAction, ChecklistItemModel } from '../checklist.model';

@Component({
  selector: 'sb-checklist-item',
  templateUrl: './checklist-item.component.html',
  styleUrl: './checklist-item.component.scss',
  standalone: true,
  imports: [CommonModule, ButtonComponent, IconComponent, RouterModule],
})
export class ChecklistItemComponent {
  @Input()
  public item!: ChecklistItemModel;

  // 0-based index
  @Input()
  public listIndex?: number;

  public onClick(action?: ChecklistAction) {
    if (!action) {
      return;
    }

    action();
  }
}
